import { Box, BoxProps, PremiumSummary, smBumps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../../domain'
import { usePromotion } from '../../../../hooks/covers'
import { useQuotePremiums } from '../../../../hooks/premiums'
import {
  tFormats,
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { ProductConfig } from '../../../../state/configuration'
import { toDateTime } from '../../../../util/date'
import { usePaymentSchedule } from '../../../product/paymentScheduleContext'

export interface AnnualSummaryPremiumsProps extends BoxProps {
  currentQuote: Quote
  product: ProductConfig
}

const tKey = TKey('components.annual-summary-premium')

export const AnnualSummaryPremium: FunctionComponent<AnnualSummaryPremiumsProps> = ({
  currentQuote,
  product,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const { paymentScheduleType } = usePaymentSchedule()

  const currentPremiums = useQuotePremiums(currentQuote, product)

  const promotion = usePromotion(currentQuote)

  const yearlyTotalFormatted = t(tFormats('currency.long'), {
    amount: currentPremiums.totals.yearly,
  })

  const yearlyTotal = t(tKey('yearly-total-amount'), {
    amount: yearlyTotalFormatted,
  })

  const promo = promotion?.endAt
    ? t(tKey('promotion', 'until'), {
        date: t(tFormats('date.long'), {
          value: toDateTime(promotion.endAt),
        }),
      })
    : undefined

  const header = t(tKey(paymentScheduleType, 'header'))

  const subheader = [...(paymentScheduleType === 'MONTHLY' ? [yearlyTotal] : []), promo]
    .filter(Boolean)
    .join('\n')

  const currentAmount = t(tFormats('currency.long'), {
    amount: currentPremiums.totals.discounted,
  })

  return (
    <Box p={2} {...props}>
      <PremiumSummary
        p={smBumps}
        header={header}
        subheader={subheader}
        currentAmount={currentAmount}
      />
    </Box>
  )
}
